export default "__VITE_ASSET__776bf5ee__"